<template>
  <section class="hero is-fullheight method-page">
    <PmNavbar />
    <div class="hero-body is-align-items-flex-start">
      <div class="container">
        
        <div class="columns is-multiline py-5 white-bg has-text-centered-mobile">
          <div class="column is-12">
            <p class="font-18 is-ubuntu">
              {{ this.$t("message.pages.designMethodPage.p_1") }}
            </p>            
          </div>
        </div>

        <div class="columns is-multiline white-bg mt-5 pb-5 has-text-centered-mobile">
          <div class="column is-12 pb-5">
            <p class="font-18 py-5">{{ this.$t("message.pages.designMethodPage.p_2") }} {{this.selectedProduct?.name}}</p>
            
            <p class="mt-3">{{ this.$t("message.pages.designMethodPage.p_3") }}</p>
            <button class="pyroll-button purple-bg font-white my-5" @click="selectProductEditor(this.selectedProduct.id, this.selectedProduct.resource_type, 'editor')">{{ this.$t("message.pages.designMethodPage.button_1") }}</button>

            <p class="mt-5">{{ this.$t("message.pages.designMethodPage.p_4") }}</p>
            <button class="pyroll-button green-bg font-white mt-5"
                    @click="selectProductRequestForm(this.selectedProduct.id)"
                    style="width: 300px;"
            >
              {{ this.$t("message.pages.designMethodPage.button_2") }}
            </button>
          </div>
        </div>

      </div>
    </div>
    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import addProductMixin from "@/mixins/addProduct"

export default {
  name: "DesignMethodPage",
  components: {
    PmNavbar,
    PmFooter,
  },
  mixins: [addProductMixin],
  data() {
    return {
      selectedProduct: null
    }
  },
  mounted() {
    this.selectedProduct = this.$store.getters.getProductById(this.$route.params.productId)
  },
  computed: {},
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;

.method-page {
  .cstm-font-color {
    color: $font-color-primary;
  }  
  .white-bg {
    background-color: #ffffff;
  }
}
</style>
